(() => {
  const language = document.documentElement.lang.toLowerCase();
  if (!language.startsWith('en')) return;

  const textTranslations = new Map([
    ['香港工作枱升級專門店', 'Hong Kong workspace upgrade specialist'],
    ['精選・到倉 QC・香港支援', 'CURATED · WAREHOUSE QC · HONG KONG SUPPORT'],
  ]);

  const localizeAccessibility = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const elements = [];
    if (root instanceof Element && root.matches('[aria-label="關閉"]')) elements.push(root);
    elements.push(...root.querySelectorAll('[aria-label="關閉"]'));
    elements.forEach((element) => element.setAttribute('aria-label', 'Close'));

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      const translated = textTranslations.get(textNode.nodeValue.trim());
      if (translated) textNode.nodeValue = translated;
      textNode = walker.nextNode();
    }
  };

  localizeAccessibility(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => localizeAccessibility(node));
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
